import { resolveAssetUrl } from './assets';

const legacyAvatarPaths = {
  '/avatars/pipo-avatar.png': '/characters/pipo-avatar.png',
  '/avatars/papagaio.png': '/characters/papagaio.png',
};

export const resolveAvatarUrl = (avatarUrl) => {
  const url = legacyAvatarPaths[avatarUrl] || avatarUrl || '/avatars/avatar_1.png';
  return resolveAssetUrl(url);
};
